import React, {useEffect, useState} from "react";
import {
    Avatar,
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Chip,
    Divider,
    Stack,
    Typography
} from "@mui/material";

import {useTranslation} from "react-i18next";
import {useLocation, useSearchParams} from "wouter";

import {authClient} from "./App.jsx";
import {useConfig} from "./configProvider";
import PersonIcon from "@mui/icons-material/Person";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import KeyIcon from "@mui/icons-material/Key";
import LogoutIcon from "@mui/icons-material/Logout";

const COLORS = {
  google: '#DB4437',
  microsoft: '#00a4ef',
  github: '#333333',
  linkedin: '#0077b5',
  stripe: '#635bff',
  stripeHover: '#4d45e4',
  success: '#2e7d32',
};

const Checkout = () => {
    
    const [config, setConfig] = useConfig();

    const [location, setLocation] = useLocation();

    const [searchParams] = useSearchParams();
    const product = searchParams.get("product") || null;

    const {t} = useTranslation();
    const {data: session} = authClient.useSession();

    const [customerState, setCustomerState] = useState(null);
    const [token, setToken] = useState(null);
    const [tokenPayload, setTokenPayload] = useState(null);
    const [authSession, setAuthSession] = useState(null);

    const [refresh, setRefresh] = useState(0);

    const [code, setCode] = useState("");

    const [message, setMessage] = useState("");

    const {data: sessionState} = authClient.useSession();

    const handleChange = (event) => {
        const {name, value} = event.target;
        switch (name) {
            case "currentPassword": setCurrentPassword(value); break;
            case "newPassword": setNewPassword(value); break;
            case "code": setCode(value); break;
            }
        }

    const handleSignOut = async () => {
        await authClient.signOut();
        }

    const handleRefresh = async () => {
        setRefresh(refresh + 1);
        }

    const handlePost = async () => {
        window.opener.postMessage({source: "auth", token}, "*");
        }

    const handleClipboard = async () => {
        await navigator.clipboard.writeText(token);
        }

    const handleRegisterPasskey = async () => {
        const {data, error} = await authClient.passkey.addPasskey({name: config?.passkeyName, authenticatorAttachment: "platform"});
        console.log(data, error);
        }

    const handleChangePassword = async () => {
        setLocation("/changePassword");
        }

    const handleAddSubscription = async () => {
        const {data, error} = await authClient.addSubscription({code});
        setMessage(data?.message || error?.message);
        console.log(data, error);
        }

    const handlePortal = async () => {
        const successUrl = document.location.href;

        const { data, error } = await authClient.stripe.portal({portal: config?.products[product]?.portal, successUrl});
        window.location = data?.url;
        }

    const handleUpgrade = async () => {
        setLocation("/pricing");
        }

  useEffect(() => {
        var valid = true;

        const getCustomerState = async () => {
            const authSession =await await authClient.getSession();
            await authClient.customer.sync();
            const state = await authClient.customer.state();
            const {data} = await authClient.token();
            const {token: newToken} = data;
            console.log(newToken);

            const tokenParts = newToken.split(".");
            const payload = JSON.parse(atob(tokenParts[1]));
            console.log(payload);
            setTokenPayload(payload);

            if (valid) {
                setCustomerState(state);
                setToken(newToken);
                setAuthSession(authSession);
                }
            }
        getCustomerState();
        return () => {
            valid = false;
            };
        }, [refresh]);

    var subscriber = false;

    if (tokenPayload && product) {
        if (tokenPayload.subscriptions[product] != undefined) {
            subscriber = true;
            }
        }
    const isSubscribed = subscriber;

    return  <>
                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                        <Avatar sx={{ width: 60, height: 60, bgcolor: 'primary.light' }}>
                            {sessionState?.user?.image ?
                                <img src={sessionState?.user?.image} alt="Profile Picture" style={{width:80, height: 80}}/>
                                :
                                <PersonIcon sx={{ fontSize: 16 }} />
                                }
                        </Avatar>
                    </Box>
                    <Box>
                        <Typography variant="h5" sx={{ ml: 2 }}>
                            {sessionState?.user?.name}
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="body1" sx={{ ml: 2 }}>
                            {sessionState?.user?.email}
                        </Typography>
                    </Box>

                <Typography variant="h5" fontWeight="bold">{t('Welcome')}</Typography>

                <Box sx={{ my: 2 }}>
                    <Chip
                        icon={<CheckCircleIcon />}
                        label={isSubscribed ? t('Plan: Pro') : t('Plan: Free')}
                        color={isSubscribed ? "success" : "default"}
                        variant={isSubscribed ? "filled" : "outlined"}
                        sx={{ px: 1 }}
                        />
                </Box>

                <Stack spacing={2} sx={{ mt: 4 }}>
                    {isSubscribed ? (
                        <Button
                            variant="contained"
                            startIcon={<CreditCardIcon />}
                            onClick={handlePortal}
                            sx={{ bgcolor: COLORS.stripe, '&:hover': { bgcolor: COLORS.stripeHover } }}
                            >
                            {t('Manage Billing')}
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            startIcon={<ArrowUpwardIcon />}
                            onClick={handleUpgrade}
                            sx={{ bgcolor: COLORS.stripe, '&:hover': { bgcolor: COLORS.stripeHover } }}
                            >
                            {t('Upgrade')}
                        </Button>
                    )}

                    <Button variant="outlined" startIcon={<FingerprintIcon />} color="inherit" onClick={handleRegisterPasskey}>
                        {t('Register new Passkey')}
                    </Button>

                    <Button variant="outlined" startIcon={<KeyIcon />} color="inherit" onClick={handleChangePassword}>
                        {t('Change Password')}
                    </Button>

                    <Divider />

                    <Button variant="contained" color="error" startIcon={<LogoutIcon />} onClick={handleSignOut}>
                        {t('Sign Out')}
                    </Button>
                </Stack>
            </CardContent>
            <Divider />
                <Card>
                    <CardHeader title={t("Debug")} />
                    <CardActions>

                        <Button onClick={handleRefresh} variant={"contained"}>{t("Refresh")}</Button>
                        <Button onClick={handlePost} variant={"contained"}>{t("Post")}</Button>
                    </CardActions>
                </Card>

                <Card>
                    <CardHeader title={t("Add Subscription")} />
                    <CardContent>
                        <input type={"text"} placeholder={t("Code")} name={"code"} onChange={handleChange} value={code} />
                    </CardContent>
                    <CardActions>
                        <Button onClick={handleAddSubscription} variant={"contained"}>{t("Add Subscription")}</Button>
                    </CardActions>
                </Card>

                <Card>
                    <CardHeader title={t("Customer State")}/>
                    <CardContent>
                         <h2>{t("Customer State")}</h2>
                        <pre>
                         <code>{JSON.stringify(customerState,"", 2)}</code>
                        </pre>
                        <h2>{t("Auth Session")}</h2>
                        <pre>
                        <code>{JSON.stringify(authSession,"", 2)}</code>
                        </pre>
                        <h2>{t("Token")}</h2>
                        <code>{token}</code>
                        <h2>{t("Token Payload")}</h2>
                        <pre><code>{JSON.stringify(tokenPayload,"", 2)}</code></pre>
                    </CardContent>
                    <CardActions>
                        <Button onClick={handleClipboard} variant={"contained"}>{t("Clipboard")}</Button>
                    </CardActions>
                </Card>
        </>;
    }

    export default Checkout;